import {
	Button,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
	useToast
} from '@chakra-ui/react';
import { useDeleteCarousel } from 'hooks/carousel';

const RemoveImage = ({ isOpen, onClose, image, reorder }) => {
	const toast = useToast();

	const onCloseModal = () => {
		onClose();
	};

	const [removeImage, { loading }] = useDeleteCarousel({
		onSuccess: () => {
			toast({
				title: 'Imagem removida com sucesso.',
				status: 'success',
				duration: 5000,
				isClosable: true
			});
			reorder(image.id, image.order)
			onCloseModal();
		},
		onError: () => {
			toast({
				title: 'Ocorreu um erro.',
				status: 'error',
				duration: 5000,
				isClosable: true
			});
		}
	});
	

	const onSubmit = () => {
		removeImage({
			variables: {
				where: {
					column: 'ID',
					operator: 'EQ',
					value: image.id
				}
			}
		});
	};

	return (
		<Modal
			isCentered
			onClose={onCloseModal}
			isOpen={isOpen}
			motionPreset="slideInBottom"
		>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Remover Imagem</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Text fontSize="md">Por favor, confirme a ação de exclusão.</Text>
				</ModalBody>
				<ModalFooter>
					<Button
						mr={3}
						variant="ghost"
						disabled={loading}
						onClick={onCloseModal}
					>
						Cancelar
					</Button>
					<Button
						isLoading={loading}
						disabled={loading}
						colorScheme="red"
						onClick={onSubmit}
					>
						Remover
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default RemoveImage;
